<template>
  <v-navigation-drawer
    v-model="showMe"
    app
    right
    clipped
    mobile-break-point="670"
    width="450"
    mini-variant-width="300"
  >

    <wsr-startscreen v-if="showStartscreen" />

    <v-card class="info-card" v-if="!showStartscreen">

      <v-img
        :src="imgPath"
        aspect-ratio="1.5"
      ></v-img>

      <v-card-title primary-title class="wsr-text">
        <div>
          <h3 class="headline mb-0">{{ title }}</h3>
          <div> {{ description }} </div>

          <div style="margin-top: 15px;">
            <br>
            <span v-if="website">
              Zum vollständigen <a :href="website" target="_blank">Wikipedia-Artikel</a>
            </span>
            <br>
            <span style="font-size:smaller;">Quelle Foto und Text: Wikipedia</span>
          </div>

        </div>
      </v-card-title>

      <v-card-actions v-if="isMobile">
        <v-btn flat color="gray" @click="showMe=false">Zur Karte</v-btn>
      </v-card-actions>

    </v-card>

  </v-navigation-drawer>
</template>

<script>

import { WguEventBus } from '../../src/WguEventBus';
import { WikipediaApi } from '../WikipediaApi';
import { Device } from '../util/Device';
import { Mapable } from '../../src/mixins/Mapable';
import Startscreen from './Startscreen';

export default {
  name: 'wsr-sidebar',
  mixins: [Mapable],
  components: {
    'wsr-startscreen': Startscreen
  },
  props: {
    value: {type: Boolean},
    color: {type: String, required: false, default: 'red darken-3'}
  },
  data () {
    return {
      showMe: this.value,
      showStartscreen: true,
      featProperties: null,
      title: '',
      description: '',
      imgDesc: '',
      imgPath: '',
      website: null
    }
  },
  computed: {
    isMobile () {
      return Device.isMobile();
    }
  },
  watch: {
    showMe (val) {
      this.$emit('toggle', val);
    }
  },
  mounted () {
    var me = this;

    WguEventBus.$on('wsr-sidebar-hide', () => {
      me.showMe = false;
    });

    WguEventBus.$on('wsr-feature-click', function (clickFeature) {
      const feat = clickFeature;
      if (!feat) {
        me.showStartscreen = true;
        return;
      }

      const villageName = feat.get('name');
      const wikipediaTitle = feat.get('wikipedia');
      const wikipediaQuery = wikipediaTitle || villageName;

      me.title = villageName;

      WikipediaApi.loadArticle(wikipediaQuery).then((wikipediaPages) => {
        const firstPage = wikipediaPages[Object.keys(wikipediaPages)[0]];

        if (firstPage) {
          me.showStartscreen = false;
          me.description = firstPage.extract;
          me.website = 'https://de.wikipedia.org/wiki/' + wikipediaTitle || villageName;

          const randomImgName = WikipediaApi.getRandomImageName(firstPage);
          if (randomImgName !== null) {
            WikipediaApi.loadImage(randomImgName).then((imgJson) => {
              const firstImg = imgJson[Object.keys(imgJson)[0]];
              if (firstImg && firstImg.imageinfo && firstImg.imageinfo.length > 0) {
                me.imgPath = firstImg.imageinfo[0].url;
                me.imgDesc = firstImg.imageinfo[0].descriptionshorturl;
                // TODO catch error of promise
              }
            })
          }
        }
      });

      me.showMe = true;
    });
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound () {
      var me = this;

      me.map.on('singleclick', me.onMapClick);
    },
    /**
     * Handler for 'singleclick' on the map.
     * Collects data and passes it to corresponding objects.
     *
     * @param  {ol/MapBrowserEvent} evt The OL event of 'singleclick' on the map
     */
    onMapClick (evt) {
      const me = this;
      let feature = me.map.forEachFeatureAtPixel(evt.pixel,
        (feature, layer) => {
          return feature;
        });

      WguEventBus.$emit('wsr-feature-click', feature);
    }
  }
}
</script>

<style scoped>
  a {
    color: inherit !important;
  }
</style>



// WEBPACK FOOTER //
// app/components/Sidebar.vue